import css from 'styled-jsx/css';

const styles = css.global`#partiu-gp-premio {
  padding: 56px 0;
  background: #f6f6f8;
}

#partiu-gp-premio .eyebrow {
  margin: 0 0 4px;
  color: #222;
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 400;
  text-align: center;
}

#partiu-gp-premio .titulo {
  margin: 0 0 24px;
  color: #222;
  font-family: 'SantanderHeadline';
  font-size: 28px;
  font-weight: 800;
  line-height: 32px;
  text-align: center;
}

#partiu-gp-premio .itens {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  margin-bottom: 24px;
}

#partiu-gp-premio .item {
  width: 320px;
  max-width: 100%;
  background: #fff;
  border-radius: 24px;
  overflow: hidden;
}

#partiu-gp-premio .item-img {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
}

#partiu-gp-premio .item-texto {
  margin: 0;
  padding: 24px;
  color: #222;
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
}

#partiu-gp-premio .cta {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: fit-content;
  margin: 0 auto 24px;
  padding: 0 32px;
  border-radius: 999px;
  background: #ec0000;
  color: #fff;
  font-family: 'SantanderText';
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 350ms linear;
}

#partiu-gp-premio .cta:hover {
  background-color: #f14c4c;
}

#partiu-gp-premio .disclaimer {
  margin: 0;
  color: #444;
  font-family: 'SantanderMicroText';
  font-size: 12px;
  line-height: 18px;
  text-align: center;
}

@media (min-width: 992px) {
  #partiu-gp-premio .eyebrow {
    font-family: 'SantanderHeadline';
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 16px;
  }

  #partiu-gp-premio .titulo {
    margin: 0 0 44px;
    font-size: 54px;
    line-height: 62px;
    margin-left: auto;
    margin-right: auto;
  }

  #partiu-gp-premio .itens {
    flex-direction: row;
    align-items: flex-start;
  }

  #partiu-gp-premio .item {
    width: auto;
    flex: 1;
  }

  #partiu-gp-premio .item-texto {
    min-height: 114px;
  }
}
`;

export default styles;